import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { Phone, CheckCircle } from "@mui/icons-material";
import { sendMailTo } from "../../Services/SmsService";
import { useSelector } from "react-redux";
import { sendLoanInquiry } from "../../Services/loanService";

const EnquiryConsentModal = ({ open, onClose, bankEmail, loanData }) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [consent, setConsent] = useState(false);
  const [pan, setPan] = useState("");
  const [panError, setPanError] = useState("");

  const loggedInUser = useSelector((state) => state.Auth.user);
  const customerEmail = loggedInUser?.personId?.email;
  const customerName = loggedInUser?.personId?.name || "Customer";
  const customerID = loggedInUser?.personId?.personId;

  //   const handleSubmit = async () => {
  //     if (!pan || !consent) {
  //       setPanError("Please fill in all fields and consent.");
  //       return;
  //     }

  //     setLoading(true);

  //     try {
  //     //   const bankEmail = "aishwarya.nimbalkar@payasystems.com"; // Later make dynamic

  //       // 📩 Email to Customer
  //       await sendMailTo({
  //         to: [customerEmail],
  //         subject: "Loan Enquiry Submitted Successfully",
  //         message: `
  //         <p>Dear ${loggedInUser?.personId?.firstName || "Customer"},</p>
  //         <p>Your loan enquiry has been successfully submitted.</p>
  //         <p><b>PAN:</b> ${pan}</p>
  //         <p>Our trusted banking partner will contact you shortly.</p>
  //         <br/>
  //         <p>Regards,<br/>Team</p>
  //       `,

  //       });

  //       // 📩 Email to Bank
  //       await sendMailTo({
  //         to: [bankEmail],
  //         subject: "New Loan Enquiry Received",
  //         message: `
  //         <p><b>New Loan Enquiry</b></p>
  //         <p><b>Customer Name:</b> ${customerName}</p>
  //         <p><b>Customer Email:</b> ${customerEmail}</p>
  //         <p><b>PAN:</b> ${pan}</p>
  //       `,
  //       });

  //       setSubmitted(true);
  //     } catch (error) {
  //       console.error("Email Error:", error);
  //     }

  //     setLoading(false);
  //   };

  const handleSubmit = async () => {
    // Check if PAN and consent are filled out
    if (!pan || !consent) {
      setPanError("Please fill in all fields and consent.");
      return;
    }

    setLoading(true);

    try {
      // 📩 Email to Customer
      await sendMailTo({
        to: [customerEmail],
        subject: "Loan Enquiry Submitted Successfully",
        message: `
        <p>Dear ${loggedInUser?.personId?.firstName || "Customer"},</p>
        <p>Your loan enquiry has been successfully submitted.</p>
        <p><b>PAN:</b> ${pan}</p>
        <p>Our trusted banking partner will contact you shortly.</p>
        <br/>
        <p>Regards,<br/>Team</p>
      `,
      });

      // 📩 Email to Bank
      await sendMailTo({
        to: [bankEmail],
        subject: "New Loan Enquiry Received",
        message: `
        <p><b>New Loan Enquiry</b></p>
        <p><b>Customer Name:</b> ${customerName}</p>
        <p><b>Customer Email:</b> ${customerEmail}</p>
        <p><b>PAN:</b> ${pan}</p>
      `,
      });

      // Send the loan inquiry data to the backend to save in the database
      const inquiryData = {
        personId: customerID,
        customer_name: customerName,
        customer_email: customerEmail,
        bank_name: loanData.bank_name, // You may use dynamic bank data
        bank_code: loanData.bank_code, // Assuming loanData has bank_code
        bank_email: bankEmail, // Dynamically fetch this if needed
        interest_rate: loanData.min_roi, // Use dynamic interest rate
        pan: pan,
      };

      // Send data to backend for saving the inquiry
      const result = await sendLoanInquiry(inquiryData); // sendLoanInquiry sends data to the backend

      // If the inquiry was successfully saved, set the submitted state to true
      if (result.success) {
        setSubmitted(true);
      } else {
        throw new Error("Failed to save the loan enquiry");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
    }

    setLoading(false);
  };
  const handleClose = () => {
    setSubmitted(false);
    setPan("");
    setConsent(false);
    onClose();
  };

  const handlePanChange = (e) => {
    const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""); // Format PAN to upper case and remove non-alphanumeric characters
    setPan(val);

    // PAN number validation regex: 5 letters + 4 digits + 1 letter
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (val && !panRegex.test(val)) {
      setPanError("Invalid PAN format. Example: ABCDE1234F");
    } else {
      setPanError("");
    }
  };

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto",
        p: 1,
      }}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 3,
          maxWidth: 600,
          width: "100%",
          boxShadow: 24,
        }}
      >
        <Box sx={{ width: "100%" }}>
          {!submitted ? (
            <>
              {/* Header Bar */}
              <Box
                sx={{
                  background:
                    "linear-gradient(90deg, #F59E0B 20%, #fccb76 80%)",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 1,
                  fontFamily: '"Inter", sans-serif', // Specific font
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 40,
                    height: 40,
                    bgcolor: "white",
                    borderRadius: 1,
                  }}
                >
                  <Phone sx={{ color: "#F59E0B", fontSize: 20 }} />
                </Box>
                <Box sx={{ ml: 2 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "white", fontWeight: 600, fontSize: "20px" }}
                  >
                    Loan Enquiry
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "white", opacity: 0.8, fontSize: "14px" }}
                  >
                    Our trusted banking partners will contact you shortly
                  </Typography>
                </Box>
              </Box>

              {/* Security Info */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F5F5F5",
                  p: 2,
                  borderRadius: 1,
                  mb: 3,
                  fontFamily: '"Inter", sans-serif',
                  marginTop: 3,
                }}
              >
                <CheckCircle sx={{ color: "green", mr: 2 }} />
                <Typography
                  variant="body2"
                  sx={{ color: "#555", fontSize: "14px" }}
                >
                  Your information is securely handled in compliance with RBI
                  guidelines. We only share your details with verified banking
                  partners.
                </Typography>
              </Box>

              {/* PAN Number */}
             {/* PAN Number */}
<Box sx={{ mb: 3 }}>
  <Typography
    variant="body2"
    sx={{ mb: 1, color: "#555", fontSize: "14px" }}
  >
    PAN Number <span style={{ color: "red" }}>*</span>
  </Typography>
  <TextField
    fullWidth
    variant="outlined"
    value={pan}
    onChange={handlePanChange}
    placeholder="e.g., ABCDE1234F"
    error={!!panError}
    helperText={panError}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        fontSize: "14px",
        borderColor: panError ? "red" : "#F59E0B", // Set border to orange or red based on error
      },
        '& .MuiOutlinedInput-root': {
                    
                    '&:hover fieldset': {
                      borderColor: '#F59E0B', // Border color on hover
                    },
                    '&.Mui-focused fieldset': {
                    borderColor: panError ? "red" : "#F59E0B", // Border color when focused (clicked)
                    },
                  },
                   
    }}
  />
</Box>

{/* Consent Checkbox */}
<FormControlLabel
  control={
    <Checkbox
      sx={{
        top: -32,
        "& .MuiSvgIcon-root": {
          color: consent ? "#F59E0B" : undefined, // Change color to orange when checked
        },
      }}
      checked={consent}
      onChange={(e) => setConsent(e.target.checked)}
    />
  }
  label={
    <Box sx={{ fontSize: "14px", color: "#555", mb: 3 }}>
      I consent to share my PAN details with trusted banking partners for loan assistance. I understand that bank representatives will contact me regarding loan offers.
    </Box>
  }
/>

              {/* Action Buttons */}
              <Box sx={{ display: "flex", justifyContent: "space-between",gap: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    flexGrow: 1,
                    borderColor: "#F59E0B",
                    fontFamily: "Inter-Medium",
                    color: "#F59E0B",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    "&:hover": {
                      borderColor: "#D97706",
                      color: "#D97706",
                    },
                  }}
                  onClick={handleClose}
                >
                  Back to offers
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    // backgroundColor: "#1570ef",
                    // color: "white",
                    // fontWeight: "bold",
                    // borderRadius: 1,
                    // "&:hover": { backgroundColor: "#0d5cb6" },
                    // fontSize: "14px",
                    // textTransform: "none",
                    flexGrow: 1,
                    marginRight: "10px",
                    backgroundColor: "#F59E0B",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "10px",
                    fontFamily: "Inter-Medium",
                    py: 1,
                    fontSize: "14px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#D97706",
                      boxShadow: "none",
                    },
                  }}
                  onClick={handleSubmit}
                  disabled={!pan || !consent}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Submit Enquiry"
                  )}
                </Button>
              </Box>
            </>
          ) : (
            /* Success State */
            <Box sx={{ textAlign: "center", py: 4 }}>
              <CheckCircle sx={{ color: "green", fontSize: 40, mb: 2 }} />
              <Typography
                variant="h6"
                sx={{ color: "#555", fontWeight: "bold", fontSize: "20px" }}
              >
                Enquiry Submitted!
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#555", mb: 3, fontSize: "14px" }}
              >
                Thank you for your interest. Our trusted banking partners will
                contact you shortly at your registered mobile number.
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#F5F5F5",
                  p: 2,
                  borderRadius: 1,
                  mb: 3,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", mb: 1, fontSize: "14px" }}
                >
                  What happens next?
                </Typography>
                <ul>
                  <li style={{ fontSize: "14px" }}>
                    You'll receive a confirmation with partner bank details
                  </li>
                  <li style={{ fontSize: "14px" }}>
                    A bank representative will call you within 24-48 hours
                  </li>
                  <li style={{ fontSize: "14px" }}>
                    Complete documentation and get your loan approved
                  </li>
                </ul>
              </Box>
              <Button variant="outlined" sx={{color: "#F59E0B", borderColor: '#F59E0B','&:hover': {
                      borderColor: '#F59E0B', 
                      backgroundColor: '#F59E0B', // Background color on hover
                      color: 'white', // Text color on hover
                    
                  },}} onClick={handleClose}>
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default EnquiryConsentModal;
